// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"eiUYbDnk","rightWrapper":"RhN5pceJ","titleLabel":"NeLCxC0K","categoryLabel":"p2nF9GHO"};